import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { BodyText, TitleText } from '@calendly/ui/components/typography'
import { useDispatch } from 'react-redux'

import { historyPush } from 'actions/core/navigation'
import { TRACKING_EVENT_NAMES } from 'hooks/analytics_events/constants'
import { useTrackOnce } from 'hooks/analytics_events/useTrack'

import { EmptyStateContainer, EmptyStateText } from './styles'

export const EmptyState = () => {
  const dispatch = useDispatch()

  useTrackOnce(true, {
    name: TRACKING_EVENT_NAMES.CTA_SHOWN,
    entities: ['user', 'organization', 'attribution'],
    properties: {
      cta_destination: 'integrations_page',
      cta_key: 'et_editor_payment',
      cta_text: 'go_to_integrations',
      cta_details: 'connect_a_payment_processor'
    }
  })

  const navigateToIntegrations = () => {
    dispatch(historyPush('/integrations?category=payments'))
  }

  return (
    <EmptyStateContainer>
      <EmptyStateText>
        <TitleText size="small" level={3}>
          {I18n.t('publisher.event_type_editor.sections.payment.empty.title')}
        </TitleText>
        <BodyText size="medium" color="muted">
          {I18n.t('publisher.event_type_editor.sections.payment.empty.description')}
        </BodyText>
      </EmptyStateText>
      <Button size="small" onClick={navigateToIntegrations}>
        {I18n.t('publisher.event_type_editor.sections.booking_page_options.payments.go_to_integrations')}
      </Button>
    </EmptyStateContainer>
  )
}
